import "./style.scss";
import pdf from "vue-pdf";

new Vue({
  el: "#js-catalog",
  components: {
    pdf,
  },
  data: {
    currentPageNum: 1,
    totalPageNum: 0,
  },
  methods: {
    prevPage() {
      if (this.currentPageNum <= 1) {
        return;
      }
      this.currentPageNum = this.currentPageNum - 1;
    },
    nextPage() {
      if (this.currentPageNum >= this.totalPageNum) {
        return;
      }
      this.currentPageNum = this.currentPageNum + 1;
    },
  },
});
